import React from 'react';
import ImgQuiz from '../../../../assets/quiz-icon.png';
import ImgHappy from '../../../../assets/happy-emoji.png';
import ImgUnHappy from '../../../../assets/unhappy-emoji.png';
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled';
import CloseCircleFilled from '@ant-design/icons/lib/icons/CloseCircleFilled';
import { Button, Radio, RadioChangeEvent } from 'antd';
import { useStore } from '../../store';
import { useParams } from 'react-router-dom';

interface IQuizOption {
  indicator?: string;
  title: string;
  hint: string;
  isCorrect: boolean;
}

interface IQuizProps {
  description: string;
  question: string;
  options: IQuizOption[];
  onCompleted?: () => void;
}
const RESULTS = {
  CORRECT: 'correct',
  WRONG: 'wrong',
};
const INDICATORS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const Quiz: React.FunctionComponent<IQuizProps> = (props) => {
  const { description, question, options, onCompleted } = props;

  const { courses, language } = useStore();
  const param = useParams();
  const p_course = param.course;
  const course = courses[p_course || ''];
  const { components: settings } = course;
  options.forEach((item, index) => {
    item.indicator = INDICATORS[index];
  });
  const [state, setState] = React.useState<{
    submitted: boolean;
    selected: IQuizOption | undefined;
    selectedValue: string;
  }>({
    submitted: false,
    selected: undefined,
    selectedValue: '',
  });

  React.useEffect(() => {
    if (onCompleted && state.submitted && state.selected?.isCorrect) {
      onCompleted();
    }
  }, [state.selected?.isCorrect, state.submitted]);

  React.useEffect(() => {
    setState({
      ...state,
      selected: options.find(
        (option) => option.indicator === state.selectedValue
      ),
    });
  }, [language]);

  if (!p_course) {
    return <div>Loading</div>;
  }
  const getAnswerStyle = (itm: string) =>
    !state.submitted || itm !== state.selected?.indicator
      ? ''
      : state.selected.isCorrect
      ? RESULTS.CORRECT
      : RESULTS.WRONG;
  const onSelected = (e: RadioChangeEvent) => {
    if (state.submitted) {
      return;
    }
    setState({
      ...state,
      selectedValue: e.target.value,
      selected: options.find((option) => option.indicator === e.target.value),
    });
  };
  const submit = () => {
    if (!state.selected) {
      return;
    }
    setState({
      ...state,
      submitted: true,
    });
  };
  const reset = () => {
    setState({
      ...state,
      submitted: false,
      selected: undefined,
    });
  };
  return (
    <div className="quiz-section">
      <h1 className="header">
        {settings?.quizHeader}
        <img className="img-quiz" src={ImgQuiz} alt="" />
      </h1>

      <div className="quiz-section-body">
        <div className="quiz-title">{settings?.quizTitle}</div>
        <p
          className="quiz-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div
          className="quiz-question"
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div className="quiz-answers">
          <Radio.Group onChange={onSelected} value={state.selectedValue}>
            {options.map((option: IQuizOption, index) => (
              <div
                key={index}
                className={`quiz-answers-item ${getAnswerStyle(
                  option.indicator || ''
                )}`}
              >
                <Radio value={option.indicator}>
                  {getAnswerStyle(option.indicator || '') ===
                  RESULTS.CORRECT ? (
                    <CheckCircleFilled />
                  ) : null}
                  {getAnswerStyle(option.indicator || '') === RESULTS.WRONG ? (
                    <CloseCircleFilled />
                  ) : null}
                  {option.indicator}. {option.title}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        </div>
        <div className={`quiz-button-section ${state.submitted ? 'hide' : ''}`}>
          <Button
            onClick={submit}
            className="quiz-submit-button"
            type="text"
            disabled={!state.selected}
          >
            <span>{settings?.submitLabel}</span>
          </Button>
        </div>
        <div className={!state.submitted ? 'hide' : ''}>
          <div
            className={`quiz-result-area correct ${
              state.selected?.isCorrect ? 'correct' : 'wrong'
            }`}
          >
            <img
              src={state.selected?.isCorrect ? ImgHappy : ImgUnHappy}
              alt=""
            />
            <div className="text">
              {state.selected?.isCorrect
                ? settings?.correctLabel
                : settings?.wrongLabel}
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: state.selected?.hint || '',
              }}
            />
            {state.selected?.isCorrect || (
              <Button
                onClick={reset}
                className="quiz-try-again-button"
                type="link"
              >
                <span>{settings?.tryLabel}</span>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Quiz.defaultProps = {
  onCompleted: undefined,
};

export default Quiz;
